import { getService } from '@4r/mf-app';
import MessageBusService from '@4r/mf-app/dist/shared/src/services/MessageBusService';
import {
  ICommandService,
  IStorageService,
  ServiceNames,
} from '@4r/mf-contracts-4services';

export function getStorageService(): IStorageService {
  return getService<IStorageService>(ServiceNames.Storage);
}

export function getCommandService(): ICommandService {
  return getService<ICommandService>(ServiceNames.Command);
}

export function getMessageBusService(): MessageBusService {
  return getService('MessageBusService');
}
